import useMediaQuery from "./useMediaQuery";

/**
 * break point 정의(추후 반응형 확장을 위해 모바일과 태블릿 임시 작성)
 */
const BREAKPOINTS = {
    mobile: '(max-width: 480px)',
    tablet: '(max-width: 768px)',
    patientOnly: '(max-width: 1830px)',
    isW1500: '(max-width: 1500px)',
    is17Inch: '(max-width: 1024px) and (max-height: 768px)',
    is19Inch: '(max-width: 1280px) and (max-height: 1024px)',
};

/**
 * 범용 breakpoint 훅
 */
export const useBreakpoint = (key) => {
    return useMediaQuery(BREAKPOINTS[key]);
}

/**
 * 필요한 해상도 export
 */
export const useMobile = () => {
    return useBreakpoint('mobile');
}

export const useTablet = () => {
    return useBreakpoint('tablet');
}

export const usePatientOnly = () => {
    return useBreakpoint('patientOnly');
}

export const useIsW1500 = () => {
    return useBreakpoint('isW1500');
}

export const useIs17Inch = () => {
    return useBreakpoint('is17Inch');
}

export const useIs19Inch = () => {
    return useBreakpoint('is19Inch');
}
